import styled from '@emotion/styled';
import { N200 } from '@atlaskit/theme/colors';
import { fontSizeSmall } from '@atlaskit/theme/constants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const BoardAndListCol = styled.div({
  display: 'flex',
  overflow: 'hidden'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const BoardAndListDetail = styled.div({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: '5%',
  fontSize: `${fontSizeSmall()}px`,
  lineHeight: '14px',
  color: `var(--ds-text-subtlest, ${N200})`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ArchivedCol = styled.div({
  marginLeft: "var(--ds-space-050, 4px)",
  flexShrink: 0,
  fontSize: `${fontSizeSmall()}px`,
  lineHeight: '14px',
  color: `var(--ds-text-subtlest, ${N200})`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const CollapsedResultDetailWrapper = styled.div({
  display: 'flex'
});